import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/highlights";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="relative w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="追剧问答"
              title="看之前，你可能想问"
              desc="关于演员表怎么看、绯闻怎么分辨、花絮都包含什么，把你最常问的几个问题整理在这里。点开任意一条即可看到回答。"
              accent="secondary"
            />
            <div className="hidden lg:flex items-center gap-3 rounded-2xl border border-background-200 bg-background-50 p-4">
              <span className="w-11 h-11 rounded-xl bg-primary-50 text-primary-600 flex items-center justify-center">
                <i className="ri-question-answer-line text-xl"></i>
              </span>
              <p className="text-sm text-foreground-600 leading-relaxed">
                还有别的疑问？本站为演示性内容站点，暂不提供真实提交入口。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8 space-y-3">
            {faqs.map((item, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={item.q}
                  className={`reveal rounded-2xl border bg-background-50 transition-colors ${
                    isOpen ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="flex items-center gap-3">
                      <span className="text-xs font-label text-primary-500 w-6 shrink-0">
                        Q{i + 1}
                      </span>
                      <span className="font-heading font-medium text-foreground-950 text-sm md:text-base">
                        {item.q}
                      </span>
                    </span>
                    <i
                      className={`shrink-0 text-lg text-foreground-400 transition-transform ${
                        isOpen ? "ri-subtract-line text-primary-500" : "ri-add-line"
                      }`}
                    ></i>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 pl-14">
                      <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}